export const Masks = {
	Zip5: '00000',
	Zip9: '00000-0000',
	Zip: '00000||00000-0000',
	Phone: '000-000-0000',
	Decimal2: '0*.00', // 1111.11
	Decimal2WithSeparator: 'separator*.2', // 1,111.11
	Decimal4WithSeparator: 'separator*.4', // 1,111.1111
	Allow3Decimals: 'separator*.3', // 1,111.111
	SSN: '000-00-0000',
	Account: '0.0000.000.000.000.000.00',
	COAAccount: 'XX.XXXXX.XXXX.XXXXX.XXXXX.XXX.XX.XXX.XXXXX',
};
